import React from 'react';

/* نفس StepProps لكن باللي محتاجه Step6 بس */
interface StepProps {
  imagePreview?: string | null;
  onImageChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isEditing?: boolean;
}

// Step 6: Upload Image
const Step6UploadImage: React.FC<StepProps> = ({
  imagePreview,
  onImageChange,
  isEditing,
}) => {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-gray-800">
        Upload Product Image
      </h3>

      <div className="text-center">
        <div className="mb-6">
          {imagePreview ? (
            <div className="relative inline-block">
              <img
                src={imagePreview}
                alt="Preview"
                className="w-64 h-64 object-cover rounded-lg shadow-md"
              />
            </div>
          ) : (
            <div className="w-64 h-64 mx-auto bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 flex flex-col items-center justify-center text-gray-500">
              <svg
                className="w-16 h-16 mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              <span className="text-sm">No image selected</span>
            </div>
          )}
        </div>

        <div>
          <label className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 cursor-pointer">
            <svg
              className="w-5 h-5 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
              />
            </svg>
            Choose Product Image
            <input
              type="file"
              required={!isEditing}
              accept="image/*"
              onChange={onImageChange}
              className="hidden"
            />
          </label>
        </div>

        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <h4 className="font-medium text-blue-800 mb-2">
            Image Requirements:
          </h4>
          <ul className="text-sm text-blue-700 space-y-1">
            <li>✓ Recommended size: 800x800 pixels</li>
            <li>✓ Supported formats: JPG, PNG, WebP</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Step6UploadImage;
